import { Route, Outlet } from '@tanstack/react-router';
import { rootRoute } from '../../app/routing/rootRoute';
import React from 'react';

// Lazily load the page components
const LoginPage = React.lazy(() => import('./pages/LoginPage'));
const ForgotPasswordPage = React.lazy(() => import('./pages/ForgotPasswordPage'));
const RegisterPolicyHolderPage = React.lazy(() => import('./pages/RegisterPolicyHolder'));
const CheckEmailPage = React.lazy(() => import('./pages/CheckEmailPage'));
const ResetPasswordPage = React.lazy(() => import('./pages/ResetPasswordPage'));

// Define auth parent route
const authRoute = new Route({
  getParentRoute: () => rootRoute,
  path: 'auth',
  component: () => <Outlet />,
});

// Export all routes including the parent
export const authRoutes = [
  authRoute,
  new Route({
    getParentRoute: () => authRoute,
    path: 'login',
    component: () => <LoginPage />,
  }),
  new Route({
    getParentRoute: () => authRoute,
      path: 'register-policyholder',
      component: () => <RegisterPolicyHolderPage />,
  }),
  new Route({
    getParentRoute: () => authRoute,
    path: 'forgot-password',
    component: () => <ForgotPasswordPage />,
  }),
  new Route({
    getParentRoute: () => authRoute,
    path: 'check-email',
    component: () => <CheckEmailPage />,
  }),
  new Route({
    getParentRoute: () => authRoute,
    path: 'reset-password/$token',
    component: () => <ResetPasswordPage />,
  }),
];
